module.exports = __webpack_public_path__ + "static/media/Social_Twitter.334ebc67.svg";